export default "__VITE_ASSET__RdSqGnJr__"